/** Tracés SVG lissés, pour les graphiques dessinés à la main (Sport). */

// Spline cubique monotone (Fritsch–Carlson) : lisse sans dépassement.
// Évite les boucles/cusps de la courbe d'essoufflement quand les points
// sont peu nombreux et espacés (périodes 7 / 15 jours).
export const monotonePath = (points) => {
  const n = points.length;
  if (n === 0) return '';
  if (n === 1) return `M ${points[0].x},${points[0].y}`;
  if (n === 2) return `M ${points[0].x},${points[0].y} L ${points[1].x},${points[1].y}`;
  const xs = points.map(p => p.x), ys = points.map(p => p.y);
  const slope = [];
  for (let i = 0; i < n - 1; i++) {
    const h = xs[i + 1] - xs[i];
    slope.push(h !== 0 ? (ys[i + 1] - ys[i]) / h : 0);
  }
  const m = new Array(n);
  m[0] = slope[0];
  m[n - 1] = slope[n - 2];
  for (let i = 1; i < n - 1; i++) {
    m[i] = slope[i - 1] * slope[i] <= 0 ? 0 : (slope[i - 1] + slope[i]) / 2;
  }
  for (let i = 0; i < n - 1; i++) {
    if (slope[i] === 0) { m[i] = 0; m[i + 1] = 0; continue; }
    const a = m[i] / slope[i], b = m[i + 1] / slope[i];
    const h = Math.hypot(a, b);
    if (h > 3) {
      const t = 3 / h;
      m[i] = t * a * slope[i];
      m[i + 1] = t * b * slope[i];
    }
  }
  let d = `M ${xs[0]},${ys[0]}`;
  for (let i = 0; i < n - 1; i++) {
    const h = xs[i + 1] - xs[i];
    const cp1x = xs[i] + h / 3, cp1y = ys[i] + m[i] * h / 3;
    const cp2x = xs[i + 1] - h / 3, cp2y = ys[i + 1] - m[i + 1] * h / 3;
    d += ` C ${cp1x.toFixed(2)},${cp1y.toFixed(2)} ${cp2x.toFixed(2)},${cp2y.toFixed(2)} ${xs[i + 1]},${ys[i + 1]}`;
  }
  return d;
};
